import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Tab from 'containers/core/tab';
import Transfer from './transfer';
import TransferFrom from './transferFrom';
import Approve from './approve';
import Allowance from './allowance';
import BalanceOf from './balanceOf';
import NotFound from 'containers/404';


class EthereumTool extends Component {
  constructor() {
    super();

    this.state = {
      leftRouters: [
        { route: '/tools/transfer', title: 'Transfer' },
        { route: '/tools/transfer-from', title: 'Transfer From' },
        { route: '/tools/approve', title: 'Approve' },
      ],
      rightRouters: [
        { route: '/tools/allowance', title: 'Allowance' },
        { route: '/tools/balance-of', title: 'Balance Of' },
      ]
    }
  }

  render() {
    return (
      <main className="main token">
        <Tab leftRouters={this.state.leftRouters} rightRouters={this.state.rightRouters} />
        <div className="tab-content">
          <Switch>
            <Redirect exact from="/tools" to="/tools/transfer" />
            <Route exact path="/tools/transfer" component={Transfer} />
            <Route exact path="/tools/transfer/:toAddress" component={Transfer} />
            <Route exact path="/tools/transfer-from" component={TransferFrom} />
            <Route exact path="/tools/approve" component={Approve} />
            <Route exact path="/tools/allowance" component={Allowance} />
            <Route exact path="/tools/balance-of" component={BalanceOf} />
            <Route path="*" component={NotFound} />
          </Switch>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  blockchain: state.blockchain
});

const mapDispatchToProps = dispatch => bindActionCreators({
  // Null
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EthereumTool);